import { render, staticRenderFns } from "./xw-flow.vue?vue&type=template&id=4f03b476&scoped=true"
import script from "./xw-flow.vue?vue&type=script&lang=js"
export * from "./xw-flow.vue?vue&type=script&lang=js"
import "./xw-flow.vue?vue&type=style&index=0&id=4f03b476&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f03b476",
  null
  
)

export default component.exports